import React, { useState, useEffect } from 'react';
import { AiOutlineArrowUp } from 'react-icons/ai';

export default function ScrollToTop() {
    // eslint-disable-next-line
    const [visible, setVisible] = useState(false);

    const handleScroll = () => {
        setVisible(window.pageYOffset > 300);
    };

    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <button name="ScollToTopButton" className="fixed bottom-4 right-4 bg-blue-900 hover:bg-black text-white font-bold p-3 rounded-full" onClick={handleClick}>
            <AiOutlineArrowUp className="text-2xl" />
        </button>
    );
};
